export default "__VITE_ASSET__Dgr1ahl4__"